/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:b63ea8e7-7703-453a-9bf2-052a9ba82f43",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_6e8izAwYe",
    "aws_user_pools_web_client_id": "3hpc4mg9241di4inh64bfjh7hg",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "prod-connect-files153206-conprod",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://otkw3g78se.execute-api.us-east-1.amazonaws.com/conprod",
            "region": "us-east-1"
        },
        {
            "name": "newApi",
            "endpoint": "https://z5u61bdwah.execute-api.us-east-1.amazonaws.com/conprod",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
